import ShortcutIcon from "@mui/icons-material/Shortcut";
import { SvgIconProps } from "@mui/material";
/**
 * Returns an arrow icon that points to the left.
 * Like this but smoother: ↰
 *     <---
 *         |
 */
export function ReturnArrowIcon(props: SvgIconProps) {
  return <ShortcutIcon sx={{ transform: "scaleX(-1)" }} {...props} />;
}
